var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDoubleCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 622,
    height: 622,
    viewBox: "0 0 622 622",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "none",
    stroke: "#2fc6a0",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 44.333328 341 L 149.095337 461 L 411 161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "none",
    stroke: "#2fc6a0",
    strokeWidth: 50,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 577.666687 163.083313 L 291.943329 463.083313 L 277.666656 444.333344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDoubleCheck);
export default __webpack_public_path__ + "static/media/ic-double-check.7d078dc9e2e94595bce2df2a4fe32cbb.svg";
export { ForwardRef as ReactComponent };